import designSystem from '@styles/designSystem'
import ReactMarkdown from 'react-markdown'

interface TextProps {
    text: string
    alignment?: 'start' | 'center' | 'end' | 'left' | 'right'
    markdown?: boolean
}

export const Text: React.FC<TextProps> = ({ 
    text,
    alignment = 'start',
    markdown = false
}) => {
    if (markdown) {
        return (
            <ReactMarkdown
                components={{
                    p: ({ children }) => 
                    <p style={{ 
                        fontSize: designSystem.fontSizeSm,
                        color: designSystem.colorTitleText,
                        marginTop: 0,
                        fontWeight: designSystem.fontWeightText,
                        lineHeight: 1.7,
                        textAlign: alignment,
                    }}>
                        {children}
                    </p>,
                    strong: ({ children }) => <strong>{children}</strong>,
                    em: ({ children }) => <em>{children}</em>,
                    a: ({ children, href }) => (
                        <a 
                            href={href} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: designSystem.colorMainAction }}
                        >
                            {children}
                        </a>
                    ),
                }}
            >
                {text}
            </ReactMarkdown>
        )
    }

    return (
        <p style={{
            fontSize: designSystem.fontSizeSm,
            color: designSystem.colorTitleText,
            marginTop: 0,
            fontWeight: designSystem.fontWeightText,
            lineHeight: 1.7,
            textAlign: alignment,
        }}>
            {text}
        </p>
    )
}

export const SmallText: React.FC<TextProps> = ({ 
    text,
    alignment = 'start',
    markdown = false
}) => {
    if (markdown) {
        return (
            <ReactMarkdown
                components={{
                    p: ({ children }) => 
                    <p style={{ 
                        fontSize: designSystem.fontSizeXsm,
                        color: designSystem.colorText,
                        marginTop: 0,
                        fontWeight: designSystem.fontWeightText,
                        lineHeight: 1.7,
                        textAlign: alignment,
                    }}>
                        {children}
                    </p>,
                    strong: ({ children }) => <strong>{children}</strong>,
                    em: ({ children }) => <em>{children}</em>,
                    a: ({ children, href }) => (
                        <a 
                            href={href} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: designSystem.colorMainAction }}
                        >
                            {children}
                        </a>
                    ),
                }}
            >
                {text}
            </ReactMarkdown>
        )
    }

    return (
        <p style={{
            fontSize: designSystem.fontSizeXsm,
            color: designSystem.colorText,
            marginTop: 0,
            fontWeight: designSystem.fontWeightText,
            lineHeight: 1.7,
            textAlign: alignment,
        }}>
            {text}
        </p>
    )
}

export const ErrorText: React.FC<TextProps> = ({ 
    text,
    alignment = 'start',
}) => {
    return (
        <span 
            style={{
                color: designSystem.colorError,
                fontSize: designSystem.fontSizeXsm,
                fontWeight: designSystem.fontWeightText,
                lineHeight: 1.7,
                textAlign: alignment,
            }}
        >
            {text}
        </span>
    )
}